export interface IMenuItem {
    name: string;
    translationKey: string | undefined;
    icon?: JSX.Element | undefined;
}

export class MenuItem implements IMenuItem {
     constructor (public readonly name: string, public readonly translationKey: string | undefined, public readonly icon?: JSX.Element) {}
 };
